import { useState } from 'react';
import { useAgentPermission } from '@entities/user';
import { FallbackBanner } from '@shared/ui/FallbackBanner';
import { Tab, TabBar, TabHint, Wrap } from './styles';
import { ApplicationsTab } from './tabs/ApplicationsTab';
import { BulkUploadTab } from './tabs/BulkUploadTab';
import { DeficitTab } from './tabs/DeficitTab';
import { LotsTab } from './tabs/LotsTab';
import { ValidityTab } from './tabs/ValidityTab';
import type { TabId } from './types';
import { TABS } from './types';

/**
 * Роут `/agents/mto/quality` — подфункция «Документы качества для АОСР». Пять
 * вкладок: реестр партий (с раскрытием → документы качества партии), применение
 * партий, действительность на дату работ (МТОК-4), дефицит (МТОК-6). Запись/
 * удаление — под `can_write`; чтение — при доступе к агенту mto.
 */
export function MtoQuality() {
  const { can_read, can_write } = useAgentPermission('mto');
  const [tab, setTab] = useState<TabId>('bulk');

  if (!can_read) {
    return (
      <FallbackBanner tone="danger" title="Доступ запрещён">
        У вас нет прав на раздел «МТО».
      </FallbackBanner>
    );
  }

  const activeTab = TABS.find((t) => t.id === tab) ?? TABS[0];

  return (
    <Wrap>
      <TabBar role="tablist" aria-label="Разделы документов качества">
        {TABS.map((t) => (
          <Tab
            key={t.id}
            type="button"
            role="tab"
            id={`qc-tab-${t.id}`}
            aria-selected={tab === t.id}
            aria-controls={`qc-panel-${t.id}`}
            $active={tab === t.id}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </Tab>
        ))}
      </TabBar>
      <TabHint>{activeTab.hint}</TabHint>

      <div role="tabpanel" id={`qc-panel-${tab}`} aria-labelledby={`qc-tab-${tab}`}>
        {tab === 'bulk' && <BulkUploadTab canWrite={can_write} />}
        {tab === 'lots' && <LotsTab canWrite={can_write} />}
        {tab === 'applications' && <ApplicationsTab canWrite={can_write} />}
        {tab === 'validity' && <ValidityTab />}
        {tab === 'deficit' && <DeficitTab />}
      </div>
    </Wrap>
  );
}

export default MtoQuality;
